import {
  Card,
  Image,
  Stack,
  Divider,
  Center,
  Box,
  Alert,
  Badge,
  Tooltip,
  Title,
  Text,
  Group,
  Anchor,
  Flex,
} from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCodeBranch,
  faTag,
  faCodeCommit,
  faClock,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";
import { StageCard } from "../utils/types";
import {
  getCardBackendUrl,
  getCardFrontendUrl,
  getGithubLink,
} from "../utils/urls";

export default function Stages(props: StageCard) {
  const updated_date = new Date(props.gitDetails.date + "Z");

  const backendRoute = getCardBackendUrl(props);
  const frontendRoute = getCardFrontendUrl(props);

  const githubLink = props.gitDetails.branch ? (
    <Anchor
      href={getGithubLink(props)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faCodeBranch} style={{ marginRight: 8 }} />
      {props.gitDetails.branch}
    </Anchor>
  ) : (
    <Text>None</Text>
  );

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Card.Section p="md">
        <Center>
          <Image
            width={50}
            height={50}
            src={props.stageDetails.pathImg}
            radius="md"
          />
        </Center>
      </Card.Section>

      <Stack mt="md" gap="sm">
        <Center>
          <Title order={2}>{props.stageDetails.name}</Title>
        </Center>
        <Flex justify={"center"} gap={30}>
          <Anchor href={backendRoute} target="_blank">
            <Text size="lg">
              Legacy{" "}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="2xs" />
            </Text>
          </Anchor>
          <Anchor href={frontendRoute} target="_blank">
            <Text size="lg">
              Angular{" "}
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="2xs" />
            </Text>
          </Anchor>
        </Flex>

        <Box mt="xs">
          <Text lineClamp={1}>{githubLink}</Text>
        </Box>

        <Box mt="xs">
          <Text lineClamp={1}>
            <FontAwesomeIcon icon={faCodeCommit} />
            <span>
              {props.gitDetails.commit ? (
                <span> {props.gitDetails.commit}</span>
              ) : (
                <em> None</em>
              )}
            </span>
          </Text>
        </Box>
      </Stack>

      <Divider my="sm" />

      <Card.Section p="sm">
        {props.gitDetails.date && (
          <Alert color="green" variant="light" title="Success">
            <Group>
              <Text size="sm">
                Updated:{" "}
                <Tooltip
                  label={
                    <>
                      <FontAwesomeIcon icon={faClock} />
                      {" " + updated_date.toLocaleTimeString("fr-FR")}
                    </>
                  }
                >
                  <Text span fw={700} style={{ borderBottom: "1px dashed" }}>
                    {updated_date.toLocaleDateString("fr-FR")}
                  </Text>
                </Tooltip>
              </Text>
            </Group>
          </Alert>
        )}
      </Card.Section>
    </Card>
  );
}
